import { Outlet } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '@/providers/auth-provider';
import { Card } from '@/components/ui/card';

/**
 * Client-side gate for /admin/* routes. The server enforces admin-only
 * access independently via `requireAdmin` middleware on /v1/admin/*; this
 * just spares non-admins from seeing 403s in the UI when they paste an
 * admin URL by mistake.
 */
export function AdminGuard() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div className="p-8 text-center text-muted-foreground">Loading…</div>;
  }

  if (!user?.isAdmin) {
    return (
      <div className="max-w-md mx-auto py-16 px-5">
        <Card className="p-8 text-center">
          <div className="h-12 w-12 rounded-xl bg-red-500/15 flex items-center justify-center mx-auto mb-4">
            <ShieldAlert className="h-6 w-6 text-red-600 dark:text-red-400" />
          </div>
          <p className="text-base font-semibold mb-1">Admin access required</p>
          <p className="text-sm text-muted-foreground">
            This area is restricted to platform administrators.
          </p>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
